
const darkTheme ={
    label: 'dark',
    background: 'black',
    title: 'white',
    typeBoxtext : 'grey',
    stats: 'green'
}

const redTheme ={
    label: 'red Theme',
    background: 'red',
    title: 'white',
    typeBoxtext : 'blue',
    stats: 'purple'
}

const luna = {
   label:'Luna',
   background:'#221C35',
   title:'#F67599',
   typeBoxtext:'#5A3A7E',
   stats:'#F67599',
}
export const themeOptions = [
    {value : darkTheme, label :'Dark'},
    {value : redTheme, label :'red Theme'},
    {value : luna, label : 'Luna'}
]